import { render, staticRenderFns } from "./ly.vue?vue&type=template&id=6c5c7462&scoped=true"
import script from "./ly.vue?vue&type=script&lang=js"
export * from "./ly.vue?vue&type=script&lang=js"
import style0 from "./ly.vue?vue&type=style&index=0&id=6c5c7462&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5c7462",
  null
  
)

export default component.exports